<template lang="pug">
footer(:class="[$style.footer, $style.localFooter]")
  div(
    :class="isRebrand? $style.rebrandLayout : ''"
    class="container font-semibold"
  )
    div(:class="$style.featured")
      div(class="text-lg font-semibold md:text-sm lg:text-lg")
        | Proudly featured on:
      picture
        source(
          type="image/webp"
          srcset="~/assets/img/footer/not_mobile_press.webp, ~/assets/img/footer/not_mobile_press@2x.webp 2x")
        img.fixed-size(
          src="~/assets/img/footer/not_mobile_press.webp"
          loading="lazy"
          width="668"
          height="25"
          alt="Press logo"
          style="max-height: 36px; max-width: fit-content;")

    div(:class="$style.siteInfo")
      div(:class="$style.contact")
        div(class="mb-ds-sm hidden md:block")
          PhoneNumber(
            :font-size="24"
            show-text)
        i18n-t(
          keypath="footer.availability"
          tag="p"
          class="mb-ds-md text-xs hidden md:block"
          scope="global")
          template(#br)
            br
        p(class="flex justify-center items-center md:inline")
          a(
            href="https://www.linkedin.com/company/anyvan"
            target="_blank"
            :class="$style.mediaIcon"
            aria-label="linkedin")
            Icon(
              transform="scale(0.6)"
              :size="30"
              name="i:linkedin")
          a(
            href="https://x.com/anyvan"
            target="_blank"
            :class="$style.mediaIcon"
            aria-label="x")
            Icon(
              transform="scale(0.6)"
              :size="30"
              name="i:x")
          a(
            href="https://www.facebook.com/AnyVanUK/"
            target="_blank"
            :class="$style.mediaIcon"
            aria-label="facebook")
            Icon(
              transform="scale(0.6)"
              :size="30"
              name="i:facebook")
          img(
            class="inline-flex md:hidden fixed-size"
            :class="$style.pciDssValidated"
            src="~/assets/img/footer/PCI_DSS_Validated.webp"
            loading="lazy"
            width="82"
            height="45"
            alt="verify logo")
        //- LanguageSelect.mt-ds-ml - need to hide for MVP
      nav(:class="$style.links")
        a(:href="`${config.v4Host}/about-us`") {{ $t('footer.about_us') }}
        a(:href="`${config.v4Host}/careers`") Careers
        a(:href="`${config.v4Host}/categories`") {{ $t('footer.get_quotes') }}
        a(v-if="user" :href="`${config.v4Host}/dashboard`" rel="nofollow") {{ $t('footer.my_anyvan') }}
        a(:href="`${config.v4Host}/removals/advice`") {{ $t('footer.faq') }}
        a(:href="`${config.v4Host}/contact-us`") {{ $t('footer.contact_us') }}
        a(:href="`${config.v4Host}/storage/`") Storage
        a(:href="`${config.v4Host}/become-a-transport-partner`") {{ $t('footer.drive_with_anyvan') }}
        a(:href="`${config.v4Host}/blog`") Blog
        a(href="https://www.myunidays.com/GB/en-GB/partners/anyvan/micro/online") Students
        a(href="https://www.avbusiness.com/") Enterprise solutions
      div(:class="[$style.trustPilot, 'text-center md:text-left']")
        client-only
          Trustpilot(
            theme="light"
            :width="Breakpoints_matchMedia('md') ? null : 168")

    hr(:class="$style.hr")

    div(:class="$style.legal")
      .text-base.font-semibold {{ $t('footer.partners_title') }}
      picture(:key="'partners'")
        source(
          type="image/webp"
          srcset="~/assets/img/footer/partners.webp, ~/assets/img/footer/partners@2x.webp 2x")
        img.fixed-size(
          src="~/assets/img/footer/partners.webp"
          loading="lazy"
          width="343"
          height="32"
          alt="partners logo")
      div(class="hidden text-right md:block lg:hidden")
        img(
          class="inline-block fixed-size"
          :class="$style.pciDssValidated"
          src="~/assets/img/footer/PCI_DSS_Validated.webp"
          loading="lazy"
          width="82"
          height="45"
          alt="verify logo")
      div(:class="$style.copy")
        nav
          a(:href="`${config.v4Host}/privacy-policy`") {{ $t('footer.privacy_policy') }}
          span |
          a(
            :href="`${config.v4Host}/terms-and-conditions`"
            target="_blank") {{ $t('footer.terms_and_conditions') }}
          span(class="hidden md:block") |
          a(:href="`${config.v4Host}/sitemap`") {{ $t('footer.sitemap') }}
        div(class="text-2xs text-center md:text-sm lg:text-left")
          | {{ $t('footer.copyright', { currentYear }) }}

    .text-center.text-xs
      | AnyVan Limited is a company registered in England and Wales. |
      | Registered address: 5th Floor, The Triangle, 5-17 Hammersmith Grove, London, W6 0LG | Company number: 06837274

</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import FooterBase from "~/components/base/footerBase"
import { GET_USER } from "~/store/auth"

export default defineComponent({
  name: "TheFooter",
  extends: FooterBase,
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    })
  },
  data() {
    const config = useRuntimeConfig()
    return {
      config: config.public
    }
  }
  // TODO Tracking should be added to click on PhoneNumber
})
</script>

<style lang="scss" module>
@import "~/assets/scss/footer.scss";
</style>
